import { NormalisedNode } from 'v2/querybuilder/types/querystore';

export const getDepthOfFilter = (
  nodes: Record<string, NormalisedNode>,
  filterID: string,
): number => {
  let depth = 0;

  let currentFilter = nodes[filterID];

  while (currentFilter.parent !== currentFilter.id) {
    if (currentFilter && currentFilter.parent) {
      currentFilter = nodes[currentFilter.parent];
      depth++;
    } else {
      break;
    }
  }

  return depth;
};
